export const THDInputLabelStyles = {
    root: {
        color: '#212120',
        fontSize: '16px',
        lineHeight: '125%',
        fontStyle: 'normal',
        fontFamily: '"helvetica-neue", Helvetica Neue, Helvetica, Arial, sans-serif',
        fontWeight: 400,
        paddingBottom: 0,
        '&$error': {
            color: '#212120',
        },
    },
    formControl: {
        position: 'inherit',
        transform: 'none',
    },
    animated: {
        transition: 'none',
    },
    shrink: {
        transform: 'none',
        transformOrigin: 'inherit',
    },
};
